import {MyWindow} from '../types/MyWindow';
import Log from '../utils/Log';

declare const window: MyWindow;

const host = window.location.host;
const href = window.location.href;
const isTestRun = href.indexOf('localhost.test') !== -1 || href === 'about:blank';
const isLocal = host.indexOf('localhost') !== -1;

let config;

if (window.tsc && window.tsc.feedbackConfig) {
   config = window.tsc.feedbackConfig;
} else if (isTestRun) {
   config = {
      webConnector: {
         tsc: {
            profilesEndpoint: '/'
         }
      },
      myAccountUrl: 'https://www.techsmith.com/notreal',
      emailAddressValidationRegex: /^([a-zA-Z0-9'_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/
   };
} else {
   Log.warn('No configs found on window.tsc.feedbackConfig!');
   config = {};
}

config.webConnector = config.webConnector || {};
config.user = config.user || {isAuthenticated: false};
config.webConnector.debug = isLocal || isTestRun;
config.webConnector.common = config.webConnector.common || {};
config.webConnector.common.initialAuthResponse = {
   AccessToken: config.user.accessToken,
   UserInfoToken: config.user.userInfoToken,
   DisplayName: config.user.displayName,
   EmailAddress: config.user.emailAddress,
   TechsmithId: config.user.techSmithId,
   ExpiresIn: config.user.accessTokenExpiresIn,
   CreationTime: config.user.accessTokenCreationTime
};
config.uploadChunkSize = 1048576; // 1MB
config.concurrentChunkUploads = 3;
config.apiPrefix = '/api/v1';
config.entitlementsApiPrefix = '/api/v1';
config.authorizationApiPrefix = '/api/v1';
config.notificationApiPrefix = '/api/v4';
config.headerReturnLink = config.headerReturnLink || '';
config.conversationVideoTitle = config.conversationVideoTitle || '';

export default Object.freeze(config);
